module.exports = __webpack_public_path__ + "static/media/cookie.735fea34.svg";